interface StatusBadgeProps {
  status: string;
}

const STATUS_MAP: Record<string, string> = {
  active: 'active',
  enabled: 'active',
  true: 'active',
  disabled: 'disabled',
  false: 'disabled',
  revoked: 'revoked',
  pending: 'pending',
  expired: 'revoked',
};

export function StatusBadge({ status }: StatusBadgeProps) {
  const normalized = status.toLowerCase();
  const variant = STATUS_MAP[normalized] ?? 'pending';

  return (
    <span className={`status-badge status-badge--${variant}`}>
      {status}
    </span>
  );
}
